import { render } from "./CertificateGeneratorIconDownload.vue?vue&type=template&id=17a3a5fc"
import script from "./CertificateGeneratorIconDownload.vue?vue&type=script&lang=js"
export * from "./CertificateGeneratorIconDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__